export { default as Tippy } from './VueTippy.vue'

export const popperOptions = { modifiers: [{ name: 'preventOverflow', options: { boundariesElement: 'viewport' } }] }

export const delay = [400, 0]
